import { z } from 'zod';

export const roleSchema = z.enum(['FREIGHT_FORWARDER', 'CROSS_DOCK', 'CONSIGNEE']);

export const transferTypeSchema = z.enum(['HANDOVER', 'TAKEOVER']);

const availableActionSchema = z.object({
    role: roleSchema,
    duns: z.string(),
    transfer_type: transferTypeSchema,
    transport_leg_id: z.string().optional(),
});

const availableActionsForShipmentSchema = z.object({
    shipment_id: z.string(),
    available_actions: z.array(availableActionSchema),
});

export const getAvailableActionsRequestSchema = z.object({
    shipment_ids: z.array(z.string()).min(1).max(50),
});

export const getAvailableActionsResponseSchema = z.object({
    items: z.array(availableActionsForShipmentSchema),
});

export type ApiGetAvailableActionsResponse = z.infer<typeof getAvailableActionsResponseSchema>;
export type ApiAvailableAction = z.infer<typeof availableActionSchema>;
export type ApiAvailableActionsForShipment = z.infer<typeof availableActionsForShipmentSchema>;
export type ApiGetAvailableActionsQuery = z.infer<typeof getAvailableActionsRequestSchema>;
export type ApiRole = z.infer<typeof roleSchema>;
